import React, { FC, PropsWithChildren } from 'react';
import { Flex } from '@cardboard-ui/react';

const BasicBar: FC<PropsWithChildren> = ({ children }) => (
  <Flex
    h={10}
    px={4}
    bg="var(--bar-bg)"
    color="var(--bar-color)"
    direction="row"
    align="center"
  >
    {children}
  </Flex>
);

export default BasicBar;
